export default __webpack_public_path__ + "static/media/raiffeisen_m2.8ef88664.png";